(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-template"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-inquiry-type]').forEach((select) => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('inquiry') !== 'wholesale') return;

    select.value = 'Retail store wholesale';
    const subject = select.form && select.form.querySelector('[name="contact[subject]"]');
    if (subject && !subject.value) subject.value = 'Wholesale supply inquiry';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puerh-meta-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-meta-landing]').forEach((landing) => {
    const mainImage = landing.querySelector('.meta-landing__gallery > img');
    if (!mainImage) return;
    landing.querySelectorAll('[data-landing-image]').forEach((button) => {
      button.addEventListener('click', () => {
        mainImage.src = button.dataset.landingImage;
        mainImage.removeAttribute('srcset');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puerh-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const currentLabel = gallery.querySelector('[data-gallery-current]');

    const loadSlide = (index) => {
      const slide = slides[(index + slides.length) % slides.length];
      const image = slide && slide.querySelector('[data-gallery-lazy]');
      if (!image) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-gallery-lazy');
    };

    if (!track || slides.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = gallery.dataset.galleryAutoplay === 'true';
    const interval = Number(gallery.dataset.galleryInterval) || 5000;
    let current = 0;
    let timer;
    let scrollTimer;
    let userPaused = false;

    const update = (index) => {
      current = (index + slides.length) % slides.length;
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === current;
        thumbnail.classList.toggle('is-active', active);
        if (active) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
      loadSlide(current);
      loadSlide(current + 1);
    };

    const goTo = (index, behavior = 'smooth') => {
      const target = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[target].offsetLeft, behavior });
      update(target);
    };

    const stop = () => {
      window.clearInterval(timer);
    };

    const start = () => {
      stop();
      if (!autoplayEnabled || reducedMotion || userPaused || document.hidden) return;
      timer = window.setInterval(() => goTo(current + 1), interval);
    };

    const pauseForUser = () => {
      userPaused = true;
      stop();
    };

    previous.addEventListener('click', () => {
      pauseForUser();
      goTo(current - 1);
    });

    next.addEventListener('click', () => {
      pauseForUser();
      goTo(current + 1);
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        pauseForUser();
        goTo(Number(thumbnail.dataset.galleryIndex));
      });
    });

    track.addEventListener('pointerdown', pauseForUser, { passive: true });
    track.addEventListener('wheel', pauseForUser, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      pauseForUser();
      goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
    });

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const closest = slides.reduce((best, slide, index) => {
          const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Number.POSITIVE_INFINITY });
        update(closest.index);
      }, 80);
    }, { passive: true });

    gallery.addEventListener('mouseenter', stop);
    gallery.addEventListener('mouseleave', start);
    gallery.addEventListener('focusin', stop);
    gallery.addEventListener('focusout', () => window.setTimeout(start, 0));
    document.addEventListener('visibilitychange', start);
    window.addEventListener('resize', () => goTo(current, 'auto'));

    track.scrollTo({ left: 0, behavior: 'auto' });
    update(0);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
